/**
 * <ry-pricing> + <ry-pricing-card>
 *
 * Pricing section with featured card variant.
 *
 * Usage:
 * <ry-pricing>
 *   <ry-pricing-card featured>
 *     <h3>Pro</h3>
 *     <div slot="price">$29<span>/mo</span></div>
 *     <ul><li>Feature 1</li></ul>
 *     <ry-button>Choose Pro</ry-button>
 *   </ry-pricing-card>
 * </ry-pricing>
 */

import { RyElement } from '../core/ry-element.js';

export class RyPricing extends RyElement {}
export class RyPricingCard extends RyElement {}

customElements.define('ry-pricing', RyPricing);
customElements.define('ry-pricing-card', RyPricingCard);
